



















import { Component, Prop, Vue } from 'vue-property-decorator';
import Overlay from '@/components/atoms/Overlay.vue';
import NewcrossButton from '@/components/atoms/NewcrossButton.vue';
import { DialogInstance } from '@/plugins/DialogPlugin';

@Component({
  components: {
    Overlay,
    NewcrossButton,
  },
})
export default class Dialog extends Vue {
  @Prop() private dialog!: DialogInstance;
}
